import React from "react";
import LakeWaves from "components/LakeWaves";

// Соёны нуруу (арын, цастай оргилтой) ба нуурын эргийн ойрын толгод — viewBox 1440×160
const SAYAN =
  "M0 160V96L90 70L160 84L250 34L300 58L360 40L440 78L520 52L600 14L660 50L720 36L800 72L880 44L960 62L1040 22L1110 58L1180 46L1260 76L1340 50L1440 70V160Z";
const SNOW = [
  "M250 34L232 44L240 42L246 47L254 43L262 48L271 44Z",
  "M600 14L575 26L585 23L592 28L602 24L610 29L620 26Z",
  "M1040 22L1018 33L1027 31L1034 36L1044 32L1052 37L1061 33Z",
];
const HILLS =
  "M0 160V118L120 98L210 112L320 84L420 106L540 90L640 108L760 80L860 102L980 88L1080 110L1200 92L1320 108L1440 96V160Z";

// "Хөх сувд" сарны усан дээрх ойлт (Hero дахь .lake-pearl-ийн доор, ~84.5% өргөнд, xl+).
// y нь эхний давалгааны хонхор (44)-оос доош, урд давалгааны орой (67)-оос дээш — үргэлж усан дотор.
const REFLECTION = [
  { y: 46, w: 84 },
  { y: 52, w: 62 },
  { y: 58, w: 44 },
  { y: 64, w: 26 },
];
const REFLECTION_X = 1217;

/**
 * Хөвсгөл нуурын дүр зураг — hero-гийн доод хэсэг (арынхаас урагш):
 * цастай Соёны нуруу → толгод → тайгын шинэсэн ой → нуурын давалгаа.
 * Урд давалгаа нь дараагийн хэсгийн өнгөтэй (frontFill).
 */
// className: байрлал (жишээ нь "absolute bottom-0 inset-x-0"); өгөхгүй бол relative
const LakeScene = ({ frontFill = "fill-white", className = "relative" }) => (
  <div aria-hidden="true" className={`h-36 md:h-52 lg:h-[17rem] pointer-events-none ${className}`}>
    {/* Уул ба ойн доод ирмэг нь давалгааны гадаргуу (давалгааны өндрийн ~70%)-тай таарна */}
    <svg
      viewBox="0 0 1440 160"
      preserveAspectRatio="none"
      className="absolute inset-x-0 bottom-10 md:bottom-16 lg:bottom-[88px] w-full h-20 md:h-32 lg:h-44"
    >
      <path d={SAYAN} className="fill-lake-mountain" />
      {SNOW.map((d) => (
        <path key={d} d={d} className="fill-lake-snow/80" />
      ))}
      <path d={HILLS} className="fill-lake-hill" />
    </svg>

    <div className="taiga-line bg-lake-forest absolute inset-x-0 bottom-10 md:bottom-16 lg:bottom-[88px] h-6 md:h-10 lg:h-12" />

    <LakeWaves
      layers={["fill-lake-water", "fill-primary/40", frontFill]}
      className="absolute inset-x-0 bottom-0 h-16 md:h-24 lg:h-32"
    />

    <svg
      viewBox="0 0 1440 120"
      preserveAspectRatio="none"
      className="hidden xl:block absolute inset-x-0 bottom-0 w-full h-32"
    >
      {REFLECTION.map(({ y, w }) => (
        <rect key={y} x={REFLECTION_X - w / 2} y={y} width={w} height="2.5" rx="1.25" className="fill-lake-ice/40" />
      ))}
    </svg>
  </div>
);

export default LakeScene;
